<template>
  <v-app style="background-color: #e2e2e5; min-height: 100vh">
    <v-app-bar app color="white">
      <div
          class="flex justify-center mb-1 mt-1"
          style="max-height: 3rem; max-width: 3rem"
      >
        <img
            src="../../assets/img/MOH_logo.png"
            style="max-height: 3rem; max-width: 3rem"
        />
      </div>
      <v-spacer/>
      <div class="v-toolbar__title headline ml-2 w-auto">
        <span class="primary--text">Human Resource Development </span>
      </div>
      <v-spacer/>
    </v-app-bar>
    <v-main>
      <div class="flex justify-center">
        <div class="self-center justify-center text-center" style="width: 90%">
          <h4>Trainee Information</h4>
          <!-- <v-divider color="#e2e2e5"></v-divider> -->
        </div>
      </div>

      <v-card class="mx-6" elevation="2" style="min-height: 40vh; ">
        <v-container class="p-7">
          <v-row>
            <v-col lg="6" md="12" sm="12">
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Full Name:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      traineeInformation.fullName
                          ? traineeInformation.fullName
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Gender:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      traineeInformation.gender
                          ? traineeInformation.gender
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Phone Number:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      traineeInformation.phoneNumber
                          ? traineeInformation.phoneNumber
                          : "-"
                    }}
                  </p>
                </div>
              </div>
            </v-col>
            <v-col lg="6" md="12" sm="12">
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Course Name:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      traineeInformation.courseName
                          ? traineeInformation.courseName
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Continual Education Unit:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      traineeInformation.continualEducationUnit
                          ? traineeInformation.continualEducationUnit
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Course Issue Date:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      traineeInformation.courseCompletionDate
                          ? traineeInformation.courseCompletionDate
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Certificate Reason:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      traineeInformation.certificateReason
                          ? traineeInformation.certificateReason
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    CPD Activity:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      traineeInformation.cpdActivity
                          ? traineeInformation.cpdActivity
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Course Owner:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      traineeInformation.courseOwner
                          ? traineeInformation.courseOwner
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Course Accreditor:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      traineeInformation.courseAccreditor
                          ? traineeInformation.courseAccreditor
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Accreditation Date:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      traineeInformation.accreditationDate
                          ? traineeInformation.accreditationDate
                          : "-"
                    }}
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-main>
  </v-app>
</template>

<script>
import {TraineeService} from "./trainees.service";

export default {
  data() {
    return {
      traineeInformation: {
        fullName: null,
        gender: null,
        birthDate: null,
        contacts: [
          {
            mobilephone: null,
            email: null,
          },
        ],
        courseCompletionDate: null,
        certificateReason: null,
        courseName: null,
        continualEducationUnit: null,
        courseOwner: null,
        courseAccreditor: null,
        cpdActivity: null,
        accreditationDate: null,
      },
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    const traineeId = this.$route.params.id;
    try {
      // The service unwraps the API response and returns the public profile.
      const traineeInformation = await TraineeService.getNewTrainee(traineeId);
      if (!traineeInformation) {
        throw new Error("Trainee information was not found");
      }
      this.traineeInformation = traineeInformation;
    } catch (e) {
      console.error(e);
      this.$toast?.error?.(
          "There was a problem fetching trainee information, Please try again!"
      );
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.wrapper {
  align-items: center;
  background-color: #e2e2e5;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}

h4 {
  font-family: sans-serif;
  margin: 1.5rem auto;
  color: gray;
  text-align: center;
  font-size: 30px;
  max-width: 100%;
  position: relative;
}

h4:before {
  content: "";
  display: block;
  width: 28%;
  height: 3px;
  background: #0e74b8;
  left: 0;
  top: 50%;
  position: absolute;
}

h4:after {
  content: "";
  display: block;
  width: 28%;
  height: 3px;
  background: #0e74b8;
  right: 0;
  top: 50%;
  position: absolute;
}

@media only screen and (max-width: 600px) {
  h4:before {
    display: none;
  }

  h4:after {
    display: none;
  }
}
</style>
  
